import { strings } from '@/i18n/strings';
import { Button } from '@components/__shared/Button/Button';
import { Seo } from '@components/__shared/Seo/Seo';
import styles from './NotFound.module.scss';

export const NotFound = () => (
	<div className={styles.wrapper}>
		<Seo title={strings.notFound.seoTitle} description={strings.notFound.seoDescription} path="/404" noindex />
		<h1>{strings.notFound.heading}</h1>
		<p>{strings.notFound.body}</p>
		<Button to="/">{strings.notFound.backHome}</Button>
	</div>
);
